import React, { useState } from 'react';
import { useMutation } from '@apollo/client';

import {
    ADD_VIEWER_AS_PROPERTY_CONTACT,
    REMOVE_VIEWER_FROM_PROPERTY_CONTACTS,
} from '@general/graphql/properties.graph';

const usePropertyContactAddRemove = ({ onCompleted, onError }) => {
    const [error, setError] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccessful, setIsSuccessful] = useState(false);

    const [addMutation] = useMutation(ADD_VIEWER_AS_PROPERTY_CONTACT, {
        onCompleted: d => onComplete(d),
        onError: e => handleError(e),
    });

    const [removeMutation] = useMutation(REMOVE_VIEWER_FROM_PROPERTY_CONTACTS, {
        onCompleted: d => onComplete(d),
        onError: e => handleError(e),
    });

    const onComplete = d => {
        setIsLoading(false);
        setIsSuccessful(true);

        if (onCompleted) {
            onCompleted(d);
        }
    };

    const handleError = e => {
        setIsLoading(false);
        setError(e);
        if (onError) {
            onError();
        }
    };

    const addViewerAsPropertyContact = React.useCallback(
        async ({ variables }) => {
            setIsLoading(true);
            await addMutation({
                variables,
            });
        },
        [addMutation]
    );

    const removeViewerFromPropertyContacts = React.useCallback(
        async ({ variables }) => {
            setIsLoading(true);
            await removeMutation({
                variables,
            });
        },
        [removeMutation]
    );

    return { addViewerAsPropertyContact, removeViewerFromPropertyContacts, isLoading, error, isSuccessful };
};

export default usePropertyContactAddRemove;
